import { gql } from '@apollo/client';

export const STOCK_CAR_SEARCH = gql`
  query StockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
    $groupIds: [String!]
    $imageIds: [String!]
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      results {
        cars {
          stockCar {
            code {
              id
            }
            id
            vin
            titleText
            model {
              name
              salesModelyear
              id {
                code
              }
            }
            qualityLabel {
              label
              name
            }
            carPrices {
              label
              price {
                value
                valueAsText
                formattedValue
              }
              type
            }
            colorInfo {
              exteriorColor {
                colorInfo {
                  text
                }
                baseColorInfo {
                  code
                  text
                }
                label
              }
            }
            modelInfo {
              genericModel {
                code
                text
              }
              modelyear
            }
            dealer {
              id
              name
              region
            }
            salesInfo {
              availableFromDateInfo {
                type
                value
              }
              orderStatusText
              saleOrderTypeText
            }
            subtitleText
            cartypeText
            commissionNumber
            images(groupIds: $groupIds, imageIds: $imageIds) {
              url
              type
              mimeType
              id {
                group
                image
              }
            }
            carline {
              id
              name
            }
            dynamicAttributes {
              id
              value
            }
            engineInfo {
              fuel {
                code
                text
              }
            }
            manufacturerSpecificItems {
              ... on StockCarManufacturerAudi {
                cdbItems {
                  id
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;
